import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "message"]
  static values = { submittingText: { type: String, default: "Sending your enquiry…" } }

  connect() {
    if (this.hasMessageTarget) {
      // Focus after the browser follows the enquiry anchor.
      requestAnimationFrame(() => this.messageTarget.focus())
    }
  }

  submit() {
    if (!this.element.checkValidity()) return

    this.submitTarget.disabled = true
    this.submitTarget.textContent = this.submittingTextValue
  }
}
